<script setup lang="ts">
import './assets/style.scss'
import { useConfirm } from '@/shared/ui'

const store = useConfirm()
</script>

<template>
  <VDialog
    v-model="store.data.show"
    max-width="350"
    :persistent="store.data.loading"
    @keydown.enter="store.confirm"
    @keydown.esc="store.cancel"
  >
    <VCard>
      <VCardText>
        <div class="v-confirm">
          <div class="v-confirm__title">
            {{ store.data.title }}
          </div>

          <div class="v-confirm__content">
            {{ store.data.content }}
          </div>

          <div class="v-confirm__btn">
            <VBtn :loading="store.data.loading" @click="store.confirm">
              {{ store.data.confirmBtn }}
            </VBtn>
            <VBtn
              v-if="store.data.cancelBtn"
              color="default"
              :disabled="store.data.loading"
              @click="store.cancel"
            >
              {{ store.data.cancelBtn }}
            </VBtn>
          </div>
        </div>
      </VCardText>
    </VCard>
  </VDialog>
</template>
